import { Infoblock } from '../infoblock/infoblock';

export type ValidationMessagesProps = {
  errors: string[] | undefined;
  id: string;
};

export const ValidationMessages = ({ errors, id }: ValidationMessagesProps) => {
  if (!errors?.length) return null;
  return <Infoblock variant="error" id={id} role="alert" list={errors} />;
};
